/* ============================================================
   ANJUS — Wishlist / Saved pieces
   Guest-friendly: saved handles live in the browser (localStorage),
   so no sign-in is required to save. Self-contained; does not touch
   global.js. Buttons are marked up with [data-wishlist-toggle] +
   data-handle; the saved page uses [data-wishlist-page] with each
   candidate card as [data-wishlist-item data-handle="…"].
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'anjus.wishlist.v1';
  var GOLD = '#9A6B1E';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    if (!handle) return false;
    var list = read(); var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    return i === -1; // true when now saved
  }
  function count() { return read().length; }

  function paint(btn) {
    var saved = has(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Saved — tap to remove' : (btn.getAttribute('data-label') || 'Save'));
    var svg = btn.querySelector('svg');
    if (svg) { svg.style.fill = saved ? GOLD : 'none'; svg.style.stroke = GOLD; }
  }
  function paintAll() { document.querySelectorAll('[data-wishlist-toggle]').forEach(paint); }
  function updateCounts() {
    var c = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = c; el.hidden = c === 0;
    });
    // Floating "view saved pieces" button — only shown once something is saved.
    // Toggle display (not just [hidden]) because the button's inline display:flex
    // would otherwise override the hidden attribute and keep it visible.
    document.querySelectorAll('[data-wishlist-fab]').forEach(function (el) {
      el.hidden = c === 0;
      el.style.display = c === 0 ? 'none' : 'flex';
    });
  }

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var list = read(), shown = 0;
    page.querySelectorAll('[data-wishlist-item]').forEach(function (el) {
      var saved = list.indexOf(el.getAttribute('data-handle')) > -1;
      el.hidden = !saved;
      if (saved) shown++;
    });
    var empty = page.querySelector('[data-wishlist-empty]');
    var grid = page.querySelector('[data-wishlist-grid]');
    if (empty) empty.hidden = shown > 0;
    if (grid) grid.hidden = shown === 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      toggle(btn.getAttribute('data-handle'));
      paint(btn); updateCounts(); renderPage();
      return;
    }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      var h = rm.getAttribute('data-handle');
      if (has(h)) toggle(h);
      paintAll(); updateCounts(); renderPage();
    }
  });

  // Floating button lives in the footer's espresso colour, which would vanish
  // against the footer itself. When it crosses over the footer, flip it to a
  // champagne circle with a dark heart so it stays legible.
  function setupFabFooterContrast() {
    var fab = document.querySelector('[data-wishlist-fab]');
    var footer = document.querySelector('.site-footer');
    if (!fab || !footer || !('IntersectionObserver' in window)) return;
    var svg = fab.querySelector('svg');
    var badge = fab.querySelector('[data-wishlist-count]');
    function setOver(over) {
      fab.style.background = over ? '#E7C67C' : 'var(--footer-bg, #2A0F04)';
      if (svg) { var c = over ? '#2A0F04' : '#E7C67C'; svg.style.fill = c; svg.style.stroke = c; }
      if (badge) { badge.style.background = over ? '#2A0F04' : '#9A6B1E'; badge.style.color = '#F4EDE1'; }
    }
    var io;
    function build() {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (e) { setOver(e[0].isIntersecting); },
        { rootMargin: '-' + Math.max(0, window.innerHeight - 90) + 'px 0px 0px 0px' });
      io.observe(footer);
    }
    build();
    window.addEventListener('resize', build, { passive: true });
  }

  function init() { paintAll(); updateCounts(); renderPage(); setupFabFooterContrast(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();